<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-rows>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-single-select-edit-control [(ngModel)]="model.data.type"
                                                                [allowClearSelectionOption]="false"
                                                                [formControlName]="'type'">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="'Basket Sales'"
                                                           label="wbo.basket-analysis-report.options.type.basketSales"></wbo-select-option>
                                        <wbo-select-option [value]="'A+B Analysis'"
                                                           label="wbo.basket-analysis-report.options.type.abAnalysis"></wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </fui-column>
                            <fui-column>
                                <wbo-numeric-edit-control formControlName="limit" [decimals]="0"
                                                          [(ngModel)]="model.data.limit"></wbo-numeric-edit-control>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                    <fui-row>
                        <fui-two-columns>
                            <fui-column>
                                <wbo-entity-sub-group-by-report-criteria></wbo-entity-sub-group-by-report-criteria>
                            </fui-column>
                        </fui-two-columns>
                    </fui-row>
                </fui-rows>
            </fui-row>
            <fui-row>
                <wbo-sellable-report-selection></wbo-sellable-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
